import React, {useState} from 'react';
import {Popover} from '@mantine/core';
import {Container, Input, Button, OptionList, Option} from './styles';
import {SelectDataProps} from 'shared/types/select-data';

interface Props {
  value?: SelectDataProps;
  onChange: (value: SelectDataProps) => void;
  fields: SelectDataProps[];
  opened: boolean;
  open: () => void;
  close: () => void;
  themeLess?: boolean;
}

const FieldSelect: React.FC<Props> = ({
  onChange,
  value,
  fields,
  opened,
  open,
  close,
  themeLess,
}) => {
  const [searchText, setSearch] = useState('');

  const availableOptions = fields.filter(
    (option) =>
      option.label.toLocaleLowerCase().search(searchText.toLocaleLowerCase()) >=
      0,
  );

  return (
    <Popover
      opened={opened}
      onClose={close}
      zIndex={1001}
      position="bottom-start"
      styles={{
        dropdown: {padding: 0, borderRadius: 6},
      }}>
      <Popover.Target>
        <Button onClick={open} active={opened} {...{themeLess}}>
          {value?.label ?? 'Selecionar filtro'}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Container>
          <Input
            placeholder="Pesquisar"
            autoFocus
            onChange={(e) => setSearch(e.target.value)}
          />
          <OptionList>
            {availableOptions.map((option, index) => (
              <Option
                className="ignore"
                {...{active: value?.value === option.value}}
                key={index}
                onClick={() => onChange(option)}>
                {option?.label}
              </Option>
            ))}
          </OptionList>
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default FieldSelect;
